export const QIMA_IQ_TRACKING_FEATURE_NAME = 'qima iq';

export const QIMA_IQ_TRACKING_SOURCE_TYPE = 'qima iq';

/** QIMA IQ event names agreed with Data (SP-37860). */
export enum EQimaIqEventName {
  BOOKING_INITIATED = 'qiq_booking_initiated',
  PLANNER_MENU_CLICK = 'qiq_planner_menu_click',
  PLANNER_PRODUCT_FAMILY_SELECTED = 'qiq_planner_product_family_selected',
  PLANNER_SITE_SELECTED = 'qiq_planner_site_selected',
  PLANNER_VIEW = 'qiq_planner_view',
  PRODUCT_FAMILY_FILTER_USE = 'qiq_product_family_filter_use',
  RECOMMENDATION_CTA_CLICK = 'qiq_recommendation_cta_click',
  RECOMMENDATION_DISPLAYED = 'qiq_recommendation_displayed',
  SIMULATION_BACK = 'qiq_simulation_back',
  SIMULATION_RESULT_VIEW = 'qiq_simulation_result_view',
  SIMULATION_RUN = 'qiq_simulation_run',
  SITE_CLICK = 'qiq_site_click',
  SITE_SEARCH = 'qiq_site_search',
  SITES_SORT = 'qiq_sites_sort',
  SITES_TAB_VIEW = 'qiq_sites_tab_view',
  SUPPLIER_MESSAGE_COPY = 'qiq_supplier_message_copy',
  SUPPLIER_MESSAGE_EDIT = 'qiq_supplier_message_edit',
  SUPPLIER_MESSAGE_OPEN = 'qiq_supplier_message_open',
  SUPPLIER_MESSAGE_SEND = 'qiq_supplier_message_send',
  SUPPLIER_SITES_EXPAND = 'qiq_supplier_sites_expand',
  SUPPLIERS_SITES_VIEW = 'qiq_suppliers_sites_view',
  TIER_BAR_FILTER_CLICK = 'qiq_tier_bar_filter_click',
  TIER_BREAKDOWN_VIEW = 'qiq_tier_breakdown_view',
}
